<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
        loading: false,
        email: '',
        password: ''
      }
    },

    validations: {
      email: {
        required
      },
      password: {
        required
      }
    },

    methods: {
      loginUser() {
        this.$v.$touch()

        if (this.$v.$error) {
          return
        }

        this.loading = true
        this.$auth.login({
          data: {
            email: this.email.toLowerCase(),
            password: this.password
          },
          success() {
            this.loading = false
          },
          error(error) {
            this.loading = false
            this.$store.dispatch('Alerts/add', {
              trans: 'errors.' + error.response.data.error,
              type: 'danger'
            })
          }
        })
      }
    }
  }
</script>

<template>
  <section class="Login">
    <article class="Login_intro"
      v-once>
      <p class="Login_intro_actions has-text-centered">
        <span>{{ $t('login.no_account') }}</span>
        <router-link 
          :to="{'name': 'register'}" 
          class="button is-warning">
          {{ $t('buttons.register') }}
        </router-link>
      </p>

      <div class="content has-text-centered">
        <figure><img src="../assets/img/illus/cards.png"></figure>
        <h1>{{ $t('login.title') }}</h1>
        <div v-html="$t('login.description')"></div>
      </div>
    </article>

    <form class="Login_form"
      @submit.prevent="loginUser"
      novalidate>
      <h1 :title="$t('title')" v-once>
        <router-link :to="{name: 'home'}">
          <img src="../assets/img/logo_small.svg" :alt="$t('title')">
        </router-link>
      </h1>

      <div class="content has-text-centered" v-once>
        <p v-html="$t('login.form_text')"></p>
      </div>

      <div class="field">
        <p class="control has-icon">
          <input class="input"
            :class="{'is-danger': $v.email.$error}"
            type="email"
            v-model="email"
            :placeholder="$t('register.field.email')">
      
          <span class="icon">
            <i class="material-icons">email</i>
          </span>
        </p>

        <p class="help is-danger"
          v-show="$v.email.$error && !$v.email.required">
          {{ $t('validation.required') }}
        </p>
      </div>

      <div class="field">
        <p class="control has-icon">
          <input class="input"
            :class="{'is-danger': $v.password.$error}"
            type="password"
            v-model="password"
            :placeholder="$t('register.field.password')">
      
          <span class="icon">
            <i class="material-icons">lock_outline</i>
          </span>
        </p>

        <p class="help is-danger"
          v-show="$v.password.$error && !$v.password.required">
          {{ $t('validation.required') }}
        </p>
      </div>

      <div class="Login_form_actions">
        <button class="button is-info is-fullwidth"
          :class="{'is-loading': loading}"
          type="submit">
          {{ $t('buttons.login') }}
        </button>

        <router-link
          class="button is-warning is-fullwidth is-hidden-tablet"
          :to="{'name': 'register'}">
          {{ $t('buttons.register') }}
        </router-link>
      </div>
    </form>
  </section>
</template>

<style lang="scss">
   @import '~bulma/sass/utilities/all';

  .Login {
    .field {
      margin-bottom: pxToEm(30);
    }

    &_form {
      overflow: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 100%;
      max-width: $auth-form-width;
      padding: pxToEm(20) pxToEm(20) pxToEm(60);
      background: #fff;

      h1 {
        margin: pxToEm(40) pxToEm(40) pxToEm(80);

        img {
          display: block;
          width: 160px;
          margin: auto;
        }
      }

      &_actions {
        .button:not(:last-child) {
          margin-bottom: pxToEm(10);
        }
      }
    }

    &_intro {
      overflow: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      right: $auth-form-width;
      height: 100%;
      padding: pxToEm(100) pxToEm(60) pxToEm(20);
      background: $yellow url('../assets/img/bg-banner-home.jpg') repeat;

      &_actions {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: pxToEm(20);

        .button {
          margin-left: pxToEm(20);
        }
      }

      figure img {
        max-height: 220px;
      }
    }
  }

  @include mobile() {
    .app-page-login {
      overflow: auto;
    }

    .Login {
      &_form {
        width: 100%;
        max-width: none;
      }

      &_intro {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageLogin.vue?7569ebc6